// removed by extract-text-webpack-plugin
module.exports = {"link":"index__link___2RgOh","fit":"index__fit___3rSpv undefined","call-to-action":"index__call-to-action___3AoNq","call-to-action-bg":"index__call-to-action-bg___31V5t","to-link-btn":"index__to-link-btn___33Uye","to-link-btn-border":"index__to-link-btn-border___3dUiG"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/skin/styles/link/index.css
// module id = 1235
// module chunks = 0